<script lang="ts">
export default {
  name: 'Tip'
}
</script>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false },
  content: { type: String, required: true, default: '' },
});
</script>

<template>
  <span v-if="(content.length > 0) || (title && (title.length > 0))" class="tooltip">
      <span @click.prevent class="icon-info"></span>
      <div class="tooltip-content">
          <h4 v-if="title">{{ title }}</h4>
          <p v-if="content">{{ content }}</p>
      </div>
  </span>
</template>